import CompanySelector from './company_selector'
import SpinnerApp from '../project_form_controls/spinner_app'

export default {
  CompanySelector,
  SpinnerApp,
}
